import type { FunctionComponent } from 'react';

import SidebarNavLayout from '../../layouts/SidebarNavLayout';
import SettingsPage from '../../shared/settings/SettingsPage';
import type { RouterProps } from '../../../types';

type Props = RouterProps;

/**
 * OrganizationLanguageSettings is the top-level wrapper component for
 * all the languages settings pages.
 */
const OrganizationLanguageSettings: FunctionComponent<Props> = ({ children, location }) => (
  <SidebarNavLayout>
    <SidebarNavLayout.Nav pathname={location.pathname}>
      <SidebarNavLayout.NavHeading>
        Languages
      </SidebarNavLayout.NavHeading>
      <SidebarNavLayout.NavItem to="/account/settings/languages/java" activeKey="java">
        Java
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/languages/npm" activeKey="npm">
        NPM
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/languages/bower" activeKey="bower">
        Bower
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/languages/cocoa" activeKey="cocoa">
        Cocoapods
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/languages/ruby" activeKey="ruby">
        Ruby
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/languages/rust" activeKey="rust">
        Rust
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/languages/python" activeKey="python">
        Python
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/languages/dotnet" activeKey="dotnet">
        .NET
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/languages/git" activeKey="git">
        Git
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/languages/pub" activeKey="pub">
        Pub
      </SidebarNavLayout.NavItem>
    </SidebarNavLayout.Nav>
    <SidebarNavLayout.Content>
      <SettingsPage>
        {children}
      </SettingsPage>
    </SidebarNavLayout.Content>
  </SidebarNavLayout>
);

export default OrganizationLanguageSettings;
